module.exports = __webpack_public_path__ + "static/img/writing_woman.c455d87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/writing_woman.jpg
// module id = elWF
// module chunks = 171